import React from "react";
import PropTypes from "prop-types";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import Toast from "./Toast";

const ToastList = props => (
  <div className="cb-c-toast-list__notification-list">
    <TransitionGroup>
      {props.toasts.map(toast => (
        <CSSTransition
          key={toast.id}
          classNames="cb-c-toast-list__toast"
          timeout={{ enter: 500, exit: 700 }}
        >
          <Toast details={toast} onClose={() => props.onRemove(toast.id)} />
        </CSSTransition>
      ))}
    </TransitionGroup>
  </div>
);

ToastList.propTypes = {
  toasts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      status: PropTypes.string.isRequired,
      headerText: PropTypes.string.isRequired,
      bodyText: PropTypes.string.isRequired
    })
  ).isRequired,
  onRemove: PropTypes.func.isRequired
};

export default ToastList;
